import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AbcContainerService, AbcWindowComponent, IWindow, WindowStyle } from '@barthauer/abc/ui-components';
import { DocumentsEditorCardComponent } from './documents-editor/documents-editor-card/documents-editor-card.component';
import { DocumentsEditorTableComponent } from './documents-editor/documents-editor-table/documents-editor-table.component';
import { ImageViewerComponent } from './documents-editor/gallery/imageViewer.component';
import { PropertiesEditorFormComponent } from './properties-editor/properties-editor-form/properties-editor-form.component';
import { PropertiesEditorComponent } from './properties-editor/properties-editor.component';

@Component({
    selector: 'abc-common-editors',
    template: `<div #abcWindowContainer id="abcWindowContainer"></div>`,
    styles: [],
    standalone: false
})
export class AbcCommonEditorsComponent implements OnInit {
  private windowInstance: AbcWindowComponent;
  @ViewChild('abcWindowContainer', { read: ViewContainerRef }) abcWindow: ViewContainerRef;
  constructor(private abcContainer: AbcContainerService) {}

  ngOnInit() {}

  loadEditor(editor: Editor, id: string, objectType?: string) {
    if (this.windowInstance) this.windowInstance.ngOnDestroy();
    let component;
    let componentLabel: string;
    switch (editor) {
      case Editor.DocumentsTable:
        component = DocumentsEditorTableComponent;
        componentLabel = 'Documents Editor';
        break;
      case Editor.DocumentsCard:
        component = DocumentsEditorCardComponent;
        componentLabel = 'Documents Editor Card';
        break;
      case Editor.Properties:
        component = PropertiesEditorComponent;
        componentLabel = 'Properties Editor';
        break;
      case Editor.ImageViewerComponent:
        component = ImageViewerComponent;
        componentLabel = 'Image Viewer';
        break;
      case Editor.PropertiesEditorForm:
        component = PropertiesEditorFormComponent;
        componentLabel = ' Properties Editor Form';
        break;
      default:
        break;
    }
    const style: WindowStyle = {
      width: '1000px',
      height: '65%',
      minHeight: '65%',
      minWidth: '800px',
      maxWidth: '800px',
    };

    const WindowAttr: IWindow = {
      id: 'window-Editors',
      label: componentLabel,
      component: component,
      minimizeButton: false,
      maximizeButton: false,
      setWindowStyle: (windowStyle) => (windowStyle = style),
    };
    const window = this.abcContainer.createComponent(this.abcWindow, AbcWindowComponent, WindowAttr);
    this.windowInstance = <AbcWindowComponent>window.componentRef.instance;
    this.windowInstance.createComponentInstance().subscribe((activeComponent) => {
      activeComponent.openWindow();
      activeComponent.onAfterOpened.subscribe(() => {
        activeComponent.componentInstance.componentRef.instance.parentInfo = {
          id: id,
          objectType: objectType,
        };
      });
    });
  }
}
export enum Editor {
  Properties = 'PropertiesEditorComponent',
  DocumentsTable = 'DocumentsEditorComponentTable',
  DocumentsCard = 'DocumentsEditorComponentCard',
  ImageViewerComponent = 'ImageViewerComponent',
  PropertiesEditorForm = 'PropertiesEditorFormComponent',
}
